import React, { useEffect, useState } from "react";

const SLIDES = [
  {
    src: "/images/spitfire.jpg",
    alt: "A Supermarine Spitfire (TD314, code P-FX) photographed in level flight above the patchwork fields of the English Midlands.",
    quote: "Ninety years on, the same skies, the same silhouette.",
    positionClass: "heritage-banner__slide--spitfire",
  },
  {
    src: "/images/rafForever.jpg",
    alt: "An RAF Lightning II refuelling mid-air above the clouds — the same Royal Air Force, eight decades on.",
    quote: "Same sky. New silhouette.",
    positionClass: "heritage-banner__slide--forever",
  },
];

const ROTATE_MS = 6000;

function HeritageBanner() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const prefersReducedMotion =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion || paused) return undefined;

    const id = window.setInterval(() => {
      setActiveIndex((i) => (i + 1) % SLIDES.length);
    }, ROTATE_MS);
    return () => window.clearInterval(id);
  }, [paused]);

  return (
    <section
      className={`heritage-banner${
        SLIDES[activeIndex].positionClass === "heritage-banner__slide--forever"
          ? " heritage-banner--forever-active"
          : ""
      }`}
      aria-label="RAF heritage and modern flight imagery"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocusCapture={() => setPaused(true)}
      onBlurCapture={() => setPaused(false)}
    >
      {SLIDES.map((slide, i) => (
        <img
          key={slide.src}
          src={slide.src}
          alt={slide.alt}
          loading="eager"
          fetchpriority={i === 0 ? "high" : "low"}
          className={`heritage-banner__slide ${slide.positionClass}${
            i === activeIndex ? " is-active" : ""
          }`}
          aria-hidden={i !== activeIndex}
        />
      ))}

      <div className="heritage-banner__overlay">
        <div className="container heritage-banner__inner">
          <p className="heritage-banner__motto">— Per Ardua ad Astra —</p>
          <div className="heritage-banner__quotes">
            {SLIDES.map((slide, i) => (
              <p
                key={slide.src}
                className={`heritage-banner__quote${
                  i === activeIndex ? " is-active" : ""
                }`}
                aria-hidden={i !== activeIndex}
              >
                {slide.quote}
              </p>
            ))}
          </div>
        </div>
      </div>

      <div
        className="heritage-banner__dots"
        role="tablist"
        aria-label="Banner slides"
      >
        {SLIDES.map((_, i) => (
          <button
            key={i}
            type="button"
            role="tab"
            aria-label={`Show slide ${i + 1} of ${SLIDES.length}`}
            aria-selected={i === activeIndex}
            className={`heritage-banner__dot${
              i === activeIndex ? " is-active" : ""
            }`}
            onClick={() => setActiveIndex(i)}
          />
        ))}
      </div>
    </section>
  );
}

export default HeritageBanner;
